export default __webpack_public_path__ + "static/media/KGDenimLogo.de6456fd.png";